//src/components/property/PropertyCardSkeleton.jsx
import React from "react";
import Skeleton from "../../ui/Skeleton";

const PropertyCardSkeleton = () => {
  return (
    <article className="property-card">
      <Skeleton className="property-image-skeleton" style={{ height: 220 }} />
      <div className="property-card-body">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <Skeleton style={{ width: 80, height: 24, borderRadius: 999 }} />
          <Skeleton style={{ width: 110, height: 18 }} />
        </div>

        <Skeleton style={{ width: "88%", height: 22, marginBottom: 12 }} />
        <Skeleton style={{ width: "60%", height: 16, marginBottom: 10 }} />

        <div className="d-flex gap-2 mb-3 flex-wrap">
          <Skeleton style={{ width: 90, height: 28, borderRadius: 999 }} />
          <Skeleton style={{ width: 110, height: 28, borderRadius: 999 }} />
        </div>

        <Skeleton style={{ width: "100%", height: 16, marginBottom: 8 }} />
        <Skeleton style={{ width: "75%", height: 16, marginBottom: 16 }} />

        <div className="d-flex gap-2">
          <Skeleton style={{ flex: 1, height: 42, borderRadius: 12 }} />
          <Skeleton style={{ flex: 1, height: 42, borderRadius: 12 }} />
        </div>
      </div>
    </article>
  );
};

export default PropertyCardSkeleton;
